var Vendd = (function (Vendd) {
    'use strict';
  
    var ValidationEngine = (function () {            

        var self = this, base,
            property, validation, propertiesList = [],
            firstTime = true;
        self.Errors = [];

        self.processProperties = function (options) {
            $.each(options, function (k, v) {
                var prop = self.searchProperybyName(k);
                if (prop === false) {                  
                    property = { validations: '', name: '' };
                property.validations = [];
                property.name = k;
                self.processValidations(v, property);
                propertiesList.push(property);
                } else {
                self.processValidations(v,prop);
                }

            });
        };

        self.processValidations = function (validations, property) {
            $.each(validations, function (i,v) {
                property.validations[v.rule] = {};
                if (v.hasOwnProperty('Parameters')) {
                    property.validations[v.rule].Parameters = v.Parameters;
                } else {
                    property.validations[v.rule].Parameters = [];
                }
            });
        };

        self.searchProperybyName = function (name) {
            var prop = propertiesList.find(function (x) { return x.name === name; });
            if (prop === undefined) {
                return false;
            }
            return prop;
        };

        self.validatePropertybyName = function (name,val) {
            var result = true;
            var p = self.searchProperybyName(name);
            for (var validationType in p.validations){
                var parameters = p.validations[validationType].Parameters;
                if (parameters.length == 0) {
                    result = self.validations[validationType](val);
                } else {
                    result = self.validations[validationType](val, parameters);
                }
                if (result === false) {
                    //On First Error we stop the validation
                    var error = self.validationErrors[validationType];
                    self.Errors.push({ Property: name, Error: error, Rule: validationType });
                    return result;
                }
                else {
                            
                }
            };
            return result;
        };
        self.validateAllProperties = function (model) {
            var result = true;
            for (var property in model) {
                var currentProp = self.searchProperybyName(property);
                if (currentProp !== false) {
                    if (self.validatePropertybyName(property, model[property]) == false) {
                        result = false;
                    }
                }              
            }
            if (self.Errors.length > 0) {
                result = false;
            }

            return result;
        };

        self.validations = {

            optional: function (value) {
                if ($.trim(value).length === 0)
                    return false;

                return true;
            },

            required: function (value) {
                if ($.trim(value).length > 0)
                    return true;
                return false;
            },

            isEmail: function (value) {
                var reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i;

                return reg.test(value);
            },

            isNumeric: function (value) {
                var reg = /^\d+$/;
                return reg.test(value);
            },

            isAlphaNumeric: function (value) {

                return true;
            },

            match: function (value, parameters) {

                return value === parameters[0];
            },

            length: function (value, parameters) {
                return value.length === parameters[0];
            },

            maxLength: function (value, parameters) {

                return value.length <= parameters[0];
            },

            minLength: function (value, parameters) {
                return value.length >= parameters[0];
            },

            isSocialSecurityNumber: function (value, parameters) {
                var isValid = true;

                if (accountOverrides && typeof accountOverrides.IsSocialSecurityNumberValidation === 'function') {
                    isValid = accountOverrides.IsSocialSecurityNumberValidation(value);
                }

                return isValid;
            }  
        };

        self.validationErrors = {

            optional: "This Property is Optional",

            required: "This Property must have a value",

            isEmail: "This Property must be a Valid e-mail address",

            isNumeric: "This Property Must Be Numeric",

            isAlphaNumeric: "This Property Must Be AlphaNumeric",

            match:"This Property Must  match a value",

            length: "This Property Must  must have specified length",

            maxLength: "This Property Must  must have max length",

            minLength: "This Property Must  must have min length",

            isSocialSecurityNumber: "This property must be a valid security number"
        };

        return {
            init: function (options) {
                base = this;
                base.options = options;

                self.processProperties(base.options);
            },

            resetValidationModel: function () {
                //Reset to Validation Engine to Initial state
                propertiesList.empty();
            },

            updateValidationModel: function (options) {
                self.processProperties(options);
            },

            removePropertybyName: function (propName) {
                $.each(propertiesList, function (i, prop) {
                    if (prop.Name === propName) {
                        propertiesList.pop(prop);
                        return true;
                    };
                });
                return false;
            },
          
            validateProperty: function(name,value) {
                return self.validatePropertybyName(name,value);
            },

            validateAllProperties: function (model) {
                return self.validateAllProperties(model);
            },

            getErrors: function() {
                return self.Errors;
            },
              
            addOrUpdateValidationRule: function (validationName,validationFunction,validationErrorMessage){
                self.validations[validationName] = validationFunction;
                self.validationErrors[validationName] = validationErrorMessage;
            },

            clearErrors: function () {
                setTimeout(function () { self.Errors = []; }, 200);
            },
                
        };
    });
    
    Vendd.DataValidation.Validate = function (options)
    {
        var validationEngine = options.ValidationEngine;
        var result = validationEngine.validateProperty(options.PropertyName, options.PropertyValue);
        if (result === false) {

            var errors = validationEngine.getErrors();
            var message = errors[0].Property + " Property Error: " + errors[0].Error;
            Vendd.MessageBus.publishAsync(Vendd.DataValidation, new Vendd.DataValidation.Messages.ValidationError(errors));
            //Clear Error Stack
            validationEngine.clearErrors();
            throw message;
        }
    };

    Vendd.DataValidation.ValidateModel = function (configOptions) {
        var validationEngine = configOptions.ValidationEngine;
        var result = validationEngine.validateAllProperties(configOptions.valmodel);
        if (result === false) {

            var errors = validationEngine.getErrors();
            Vendd.MessageBus.publishAsync(Vendd.DataValidation, new Vendd.DataValidation.Messages.ValidationError(errors));
            //Clear Error Stack
            var message = errors[0].Property + " Property Error: " + errors[0].Error;
            validationEngine.clearErrors();
            throw message;
        }
        else {
            Vendd.MessageBus.publishAsync(Vendd.DataValidation, new Vendd.DataValidation.Messages.ValidationSuccess({}));
            validationEngine.clearErrors();
        }
    };

    Vendd.DataValidation.BuildValidationModel = function (model) {
        var vaEng = new ValidationEngine();
        //Here i give the Options
        vaEng.init(model);
        return vaEng;
    };
    
    return Vendd;

})(Vendd || {});